'use strict';

var wishListHeart = require('../product/wishlistHeart');
var { loadUrl } = require('../utils');

/**
 * appends params to a url
 * @param {string} data - data returned from the server's ajax call
 * @param {Object} button - button that was clicked to add a product to the wishlist
 */
function displayMessage(data, button) {
    $.spinner().stop();
    var status;
    if (data.success) {
        status = 'alert-success';
    } else {
        status = 'alert-danger';
    }

    if ($('.add-to-wishlist-messages').length === 0) {
        $('body').append(
            '<div class="add-to-wishlist-messages "></div>'
        );
    }
    $('.add-to-wishlist-messages')
        .append('<div class="add-to-wishlist-alert text-center ' + status + '">' + data.msg + '</div>');

    setTimeout(function () {
        $('.add-to-wishlist-messages').remove();
        button.removeAttr('disabled');
    }, 5000);
}

/**
 * @param {string} url - url for ajax
 * @param {string} requestType - request type for Ajax
 * @param {string} pid - product id
 * @param {string} optionId - option id
 * @param {string} optionVal - value of option
 * @param {string} icon - icon that was clicked to add a product to the wishlist
 */
function addorRemoveWishlistForLoggedInUser(url, requestType, pid, optionId, optionVal, icon) {
    $.spinner().start();
    $.ajax({
        url: url,
        type: requestType,
        dataType: 'json',
        data: {
            pid: pid,
            optionId: optionId,
            optionVal: optionVal
        },
        success: function (data) {
            displayMessage(data, icon);
        },
        error: function (err) {
            displayMessage(err, icon);
        }
    });
}

/**
 * Call wishlist add/remove
 * @param {boolean} add True if add to wishlist, false if not
 */
function addRemoveWishlist(add) {
    var $this = $(this);
    var icon = $this.find($('i'));
    var url = $this.data('href');
    var pid = $this.closest('.product-detail').find('.product-id').text();
    var optionId = $this.closest('.product-detail').find('.product-option').attr('data-option-id');
    var optionVal = $this.closest('.product-detail').find('.options-select option:selected').attr('data-value-id');
    optionId = optionId || null;
    optionVal = optionVal || null;
    var currentParent = $this.closest('.add-wishlist');
    var requestType = 'get';
    if (!url) {
        return;
    }
    var loginUrl = $('.lg-valid').data('url');
    $.spinner().start();
    // Login api call to check if user is logged in.
    $.ajax({
        url: loginUrl,
        type: 'get',
        dataType: 'json',
        success: function (data) {
            // If user is logged in, make the API call to add/remove from wishlist.
            if (data.isLoggedIn) {
                if (add) {
                    currentParent.find('.add-to-wishlist').addClass('d-none');
                    currentParent.find('.added-to-wishlist').removeClass('d-none');
                    requestType = 'post';
                } else {
                    currentParent.find('.added-to-wishlist').addClass('d-none');
                    currentParent.find('.add-to-wishlist').removeClass('d-none');
                }
                $.spinner().stop();
                addorRemoveWishlistForLoggedInUser(url, requestType, pid, optionId, optionVal, icon);
            } else {
                var $pdp = $('#unique-id-pdp');
                $pdp.modal('show').find('.modal-body').spinner().start();
                loadUrl($pdp[0]).then(function () {
                    $.spinner().stop();
                });
                $('.wl-pid-pdp').data('pid', pid);

                wishListHeart.createFbAuthenticationUrls(pid);
            }
        },
        error: function () {
            $.spinner().stop();
            window.location.reload();
        }
    });
}

module.exports = {
    addToWishlist: function () {
        $('.add-to-wish-list').on('click', function (e) {
            e.preventDefault();
            addRemoveWishlist.call(this, true);
        });
    },

    removeFromWishlist: function () {
        $('.remove-from-wishlist').on('click', function (e) {
            e.preventDefault();
            addRemoveWishlist.call(this, false);
        });
    },
    initAddWishlistOnLoad: wishListHeart.initAddWishlistOnLoad
};
